import styles from "./style.module.css";
import { useContext, useEffect, useState, useRef } from "react";

import { BiCamera } from "react-icons/bi";
import Input from "../../../components/Common/Input/Input";
import { validate } from "../../Signup/Signup/validate";
import SignButton from "../../../components/Common/SignButton/SignButton";
import mainContext from "../../../context/mainContext";
import dataContext from "../../../context/dataContext";
import userRequests from "../../../components/api/userRequests";
import { Link, useNavigate } from "react-router-dom";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import imageCompression from "browser-image-compression";

import avatar from "../../../assets/images/profile_placeholder.png";

export default function Settings() {
  const navigate = useNavigate();
  const [valid, setValid] = useState([]);
  const photoInputRef = useRef();
  const [image, setImage] = useState(null); // Original uploaded image
  const [cropper, setCropper] = useState(null); // Cropper instance
  const {
    loader: { loaderFetch, setLoaderFetch },
    header: { setPageName },
  } = useContext(mainContext);
  const { userDetails, setUserDetails, serverData } = useContext(dataContext);

  useEffect(() => {
    setPageName("settings");
    return () => setPageName("");
  }, [setPageName]);

  const getDatafromForm = (formData) => ({
    firstName: formData.get("firstName"),
    lastName: formData.get("lastName"),
  });

  const onSubmit = async (e) => {
    e.preventDefault();
    const body = getDatafromForm(new FormData(e.currentTarget));
    const checkResult = validate(body);
    setValid(checkResult);
    if (checkResult.length) return;

    try {
      setLoaderFetch(true);
      userRequests
        .updateUserDetails(body, userDetails.id)
        .then(({ firstName, lastName, classId }) => {
          setUserDetails((prev) => ({ ...prev, firstName, lastName, classId }));
        })
        .catch((e) => {
          console.error("Error updating user details:", e);
        })
        .finally(() => {
          setLoaderFetch(false);
        });
    } catch (err) {
      console.error("Error in onSubmit:", err);
    }
  };

  const onImageChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      setImage(URL.createObjectURL(file)); // Set the image preview
    }
  };

  const cropImage = async () => {
    if (cropper) {
      const croppedDataURL = cropper.getCroppedCanvas().toDataURL("image/jpeg");
      try {
        // Convert data URL to a file
        const blob = await fetch(croppedDataURL).then((res) => res.blob());
        const file = new File([blob], "cropped-image.jpg", { type: "image/jpeg" });

        // Compress the file
        const compressedBlob = await imageCompression(file, {
          maxSizeMB: 0.2,
          maxWidthOrHeight: 800,
        });
        const finalFile = new File([compressedBlob], "compressed-cropped-image.jpg", {
          type: "image/jpeg",
        });

        // Upload the file
        setLoaderFetch(true);
        userRequests
          .updateUserAvatar(finalFile, userDetails)
          .then((newUserDetails) => {
            setUserDetails(newUserDetails);
          })
          .catch((error) => console.error("Error uploading avatar:", error))
          .finally(() => { setLoaderFetch(false); setImage(null); });
      } catch (error) {
        console.error("Error compressing image:", error);
      }
    }
  };


  const handleCancel = () => navigate("/");

  return (
    <form
      className={styles["settings"]}
      onSubmit={onSubmit}
      style={window.buildType === "iPhone" ? { minHeight: "85dvh" } : {}}
    >
      <input
        ref={photoInputRef}
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        onChange={onImageChange}
      />
      <div className={styles.add_image}>
        <div
          className={`${styles.avatar} ${styles.right}`}
          style={{
            backgroundImage: `url(${userDetails.image
              ? userDetails.image.includes("https://")
                ? userDetails.image
                : `${serverData.url}/${userDetails.image}`
              : avatar})`,
          }}
        >
          <span
            className={styles.cameraCircle}
            onClick={() => photoInputRef.current.click()}
          >
            <BiCamera fill="#55575A" />
          </span>
        </div>
      </div>

      {image && (
        <div className={styles.cropper}>
          <Cropper
            src={image}
            style={{ height: 400, width: "100%" }}
            aspectRatio={1}
            guides={false}
            viewMode={2}
            minCropBoxHeight={10}
            minCropBoxWidth={10}
            background={false}
            responsive={true}
            autoCropArea={1}
            checkOrientation={false}
            onInitialized={(instance) => setCropper(instance)}
          />
          <SignButton content="Crop & Upload" type="button" onClick={cropImage} />
        </div>
      )}

      <Input
        legend="First Name"
        content="First Name"
        type="text"
        name="firstName"
        defaultValue={userDetails.firstName || ""}
        valid={!valid.includes("firstName")}
      />
      <Input
        content="Last Name"
        type="text"
        name="lastName"
        legend="Last Name"
        defaultValue={userDetails.lastName || ""}
        valid={!valid.includes("lastName")}
      />
      <Input
        legend="Email"
        content="Email"
        type="email"
        name="email"
        disabled={true}
        defaultValue={userDetails.email || ""}
        valid={!valid.includes("email")}
      />
      <Input
        legend="Classroom ID"
        content="Classroom ID"
        type="text"
        disabled={true}
        name="ClassroomID"
        defaultValue={userDetails.classId || "No class id provided"}
        valid={!valid.includes("email")}
      />

      <Link to="change-password">Change Password</Link>

      <div className={styles.btnHolder}>
        <SignButton content="submit" type="submit" disable={loaderFetch} />
        <SignButton
          onClick={handleCancel}
          content="cancel"
          style={{ background: "#fff", color: "#000" }}
          type="button"
        />
      </div>
    </form>
  );
}
